import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { ButtonLink } from '..';
import { fetchOrderDetails } from '../../../actions';
import { ROUTES } from '../../../constants';
import { getIsUserLoggedIn } from '../../../utils/cookie';
import { safelyAccessNestedProperties } from '../../../utils';
import { fetchOrderHistoryOrderDetails } from '../../../actions/orderHistory';

type Props = {
  history: Object,
  onFetchOrderDetails: Function,
  onFetchOrderHistoryOrderDetails: Function,
};

class OrderDetailsLinkComponent extends Component<Props> {
  handleBackToOnlineOrders = () => {
    const {
      onFetchOrderDetails,
      history,
      onFetchOrderHistoryOrderDetails,
    } = this.props;
    const isAuth = getIsUserLoggedIn();
    const orderId = safelyAccessNestedProperties(
      ['location', 'state', 'orderId'],
      history
    );
    if (isAuth) {
      onFetchOrderHistoryOrderDetails(orderId);
      return history.push(ROUTES.PATH.ORDER_HISTORY);
    }
    return onFetchOrderDetails(history);
  };

  render() {
    return (
      <ButtonLink
        dataId="backToOnlineOrders"
        content="Back to Online Orders"
        onClick={this.handleBackToOnlineOrders}
      />
    );
  }
}

const mapDispatchToProps = {
  onFetchOrderDetails: fetchOrderDetails,
  onFetchOrderHistoryOrderDetails: fetchOrderHistoryOrderDetails,
};

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(OrderDetailsLinkComponent)
);
